import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';

import Breadcrumb from 'components/Common/Breadcrumb2';
import CreateCourse from './CreateCourse';
import CourseTable from './CourseTable';

import {
  fetchCoursesRequest,
  addCourseRequest,
} from 'store/actions'; // Adjust paths as per your structure

const CourseList = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const courses = useSelector((state) => state.Course.courses);
  const loading = useSelector((state) => state.Course.loading);
  const error = useSelector((state) => state.Course.error);

  const permissions = JSON.parse(localStorage.getItem('permissions'));
  const hasAddPermission = permissions?.some(
    (item) => item?.permission_name === 'Add Course'
  );

  const handleSubmit = (data, onClose) => {
    dispatch(addCourseRequest(data, onClose));
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      {/* Course Modal */}
      <CreateCourse
        visible={isOpen}
        handleClose={handleClose}
        onSubmit={handleSubmit}
      />

      <div className="page-content container-fluid">
        {/* Page Header */}
        <div className="d-flex justify-content-between align-items-center mx-3">
          <Breadcrumb
            title="Courses"
            breadcrumbItems={[
              { title: 'Dashboard', link: '/dashboard' },
              { title: 'Courses', link: '#' },
            ]}
          />

          {hasAddPermission && (
            <Button
              className="bg-primary text-white d-flex justify-content-center gap-1 align-items-center"
              onClick={() => setIsOpen(true)}
            >
              <i className="ti-plus"></i> Add New
            </Button>
          )}
        </div>

        {/* Course Table */}
        <CourseTable
          courses={courses?.data || []}
          totalrows={courses?.total || 0}
          loading={loading}
          error={error}
        />
      </div>
    </>
  );
};

export default CourseList;
